import '../../../common/RCE/ricos.global.scss';

import type { RichContent } from '@wix/ricos';
import { WixRicosViewer } from '@wix/ricos';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';

import {
  useDefaultBIParams,
  useInstance,
  useMember,
} from '../../../../../../contexts/widgets';
import { biSettings, pluginsViewer } from './config';

export const Viewer: FC = () => {
  const { isMobile, language } = useEnvironment();
  const { instance } = useInstance();
  const { defaultBIParams } = useDefaultBIParams();
  const { experiments } = useExperiments();
  const { id, about } = useMember();

  return (
    <WixRicosViewer
      theme={{
        palette: {
          type: 'rgb',
          textColor: 'var(--field-text-color)',
        },
        typography: {
          fontFamily: 'var(--fieldTextFont-family)',
        },
        customStyles: {
          p: {
            fontSize: 'var(--fieldTextFont-size)',
          },
        },
      }}
      isMobile={isMobile}
      plugins={pluginsViewer}
      instance={instance}
      wixExperiments={experiments}
      biSettings={{
        ...biSettings,
        postId: id ?? '',
        defaultParams: defaultBIParams,
      }}
      content={about as unknown as RichContent}
      locale={language}
      linkSettings={{ rel: { nofollow: true } }}
    />
  );
};
